import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { NumberFormatPreset } from '@procureai/ui-mui';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NumberCell } from '~/components/DataGridCustom';
import { CuriosityValueCell } from '~/components/DataGridCustom/cells/CuriosityValueCell/CuriosityValueCell';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom/DataGridCustom.types';

export interface QuantityWithUnitCellProps<R extends GridValidRowModel = any> {
  value: Union.Nullable<number>;
  unitId: Union.Nullable<string>;
  row?: R;
}

export const QuantityWithUnitCell = <R extends GridValidRowModel = any>({
  value: quantity,
  unitId,
}: QuantityWithUnitCellProps<R>) => {
  if (isNil(quantity)) {
    return <>{NULLISH_CELL_VALUE}</>;
  }

  return (
    <>
      <NumberCell value={quantity} preset={NumberFormatPreset.DECIMAL} />
      {unitId ? (
        <>
          &nbsp;
          <CuriosityValueCell ns={CuriosityNamespaceType.UNIT} value={unitId} />
        </>
      ) : null}
    </>
  );
};
